// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__19mYg","additionalInfo":"AgreementModal_additionalInfo__3PWCo"};